import { Route, Switch, useParams } from 'react-router-dom';
import { Spinner } from '@/components/ui/spinner';
import { PolicyDetailsSection } from './content/PolicyDetailsSection';
import { PolicyHeader, PolicyHeaderBand } from './content/PolicyHeader';
import { SectionNav } from './content/SectionNav';
import { SectionPlaceholder } from './content/SectionPlaceholder';
import { PolicyDetailsProvider, usePolicyDetails } from './context/PolicyDetailsContext';
import { POLICY_SECTIONS } from './sections';

function PolicyDetails() {
  const { policyId } = useParams<{ policyId: string }>();
  const { policy, loading, failed, now } = usePolicyDetails();

  return (
    <div className="flex min-h-full w-full flex-1 flex-col bg-background">
      <PolicyHeaderBand policyNumber={policy?.policyNumber}>
        {policy ? (
          <>
            <PolicyHeader policy={policy} />
            <SectionNav policyId={policyId} />
          </>
        ) : (
          <div className="pb-3.5" />
        )}
      </PolicyHeaderBand>
      <div className="px-7 py-5">
        {loading ? (
          <div className="flex w-full justify-center py-10">
            <Spinner className="size-8" />
          </div>
        ) : failed || !policy ? (
          <p className="text-sm text-muted-foreground">This policy couldn&apos;t be loaded.</p>
        ) : (
          <Switch>
            {POLICY_SECTIONS.map(({ section, path }) => (
              <Route key={section} exact path={`/policies/:policyId${path}`}>
                {section === 'details' ? <PolicyDetailsSection policy={policy} now={now} /> : <SectionPlaceholder section={section} />}
              </Route>
            ))}
          </Switch>
        )}
      </div>
    </div>
  );
}

/** The redesigned policy page: a compact header and four sections, each with its own URL. */
export const PolicyDetailsPage = () => (
  <PolicyDetailsProvider>
    <PolicyDetails />
  </PolicyDetailsProvider>
);
